// frontend/src/pages/TermsOfService.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/TermsOfService.css';

const TermsOfService = () => {
  const [content, setContent] = useState('');
  const [effectiveDate, setEffectiveDate] = useState('23-08-2025');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTermsContent = async () => {
      try {
        setLoading(true);
        // Add timestamp to prevent caching
        const timestamp = new Date().getTime();
        const response = await axios.get(`/api/admin/terms-privacy/terms?t=${timestamp}`, {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        // console.log('Terms API Response:', response.data);
        if (response.data && response.data.content) {
          setContent(response.data.content);
          setEffectiveDate(response.data.effectiveDate || '23-08-2025');
          // console.log('Terms content loaded successfully, length:', response.data.content.length);
          // console.log('Last updated:', response.data.lastUpdated);
        } else {
          // console.warn('No content found in Terms API response');
        }
      } catch (error) {
        // console.error('Error fetching Terms and Conditions:', error);
        // console.error('Error details:', error.response?.data || error.message);
        // If API fails, content will remain empty and show nothing
      } finally {
        setLoading(false);
      }
    };

    fetchTermsContent();
  }, []);

  if (loading) {
    return (
      <div className="terms-container">
        <div className="terms-content" style={{ textAlign: 'center', padding: '40px' }}>
          <p>Loading Terms and Conditions...</p>
        </div>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="terms-container">
        <div className="terms-content" style={{ textAlign: 'center', padding: '40px' }}>
          <p>Terms and Conditions content is not available at the moment.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-container">
      <div className="terms-content" dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default TermsOfService;
